import React from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {I18n} from '../../I18n/components/companyMarket';
import Application from '../Application/Application';
import {MARKETVIEW} from '../../helpers/constants';

const ViewAppModal = (props) => {
	return (
		<Modal className="view-app-modal" isOpen={props.viewAppModal} toggle={props.viewAppModalToggle}>
			<ModalHeader toggle={props.viewAppModalToggle}>{I18n[props.lang].app}</ModalHeader>
			<ModalBody>
				<Application
					activeAppId={props.activeAppId}
					activeApks={props.activeApkIds}
					selectActiveApk = {props.selectActiveApk}
					view={MARKETVIEW.COMPANY_MARKET}
					closeModal={props.viewAppModalToggle}
				/>
			</ModalBody>
		</Modal>
	)
};

export default ViewAppModal;



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/ViewAppModal.js